import createModel, { prop } from './lib/create_model';
import Snippet from 'models/answers/snippet';

const TeamAssistPanel = createModel({
  modelName: 'TeamAssistPanel',

  properties: {
    answer: prop(Snippet),
  },

  statics: {
    create(attrs = {}) {
      return new this(attrs);
    },
  },
});

export default TeamAssistPanel;
